import { Button, Snackbar, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { type SyntheticEvent, useState } from "react";
import { useFormsContext } from "../../../../context/FormsContext";
import { Alert } from "@mui/lab";
import { deleteUserFormAsset } from "../../../../repositories/FormsRepository";
import { ButtonWithLoading, ErrorModal, MesfModal } from "@dexteel/mesf-core";

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
};

export const DeleteUserFormAssetDialog = ({ show, onHide }: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [error, setError] = useState<string>("");
	const [userFormAssetRemovedSuccess, setUserFormAssetRemovedSuccess] =
		useState<boolean>(false);
	const {
		state: {
			FormId,
			userFormAssetDataSelectedInTable: { UserId, UserName, FormAssetId },
		},
	} = useFormsContext();

	const handleCancel = () => {
		setIsSubmitLoading(false);
		onHide(false);
	};

	const handleClose = (
		event: Event | React.SyntheticEvent,
		reason?: string,
	) => {
		if (reason === "clickaway") {
			return;
		}
		setUserFormAssetRemovedSuccess(false);
	};

	const handleRemoveUserFormAsset = async () => {
		setIsSubmitLoading(true);

		const res = await deleteUserFormAsset(UserId, FormAssetId);
		if (res.ok) {
			setUserFormAssetRemovedSuccess(true);
			setIsSubmitLoading(false);
			onHide(true);
		} else {
			setError(res.message);
			setIsSubmitLoading(false);
		}
	};

	return (
		<>
			<MesfModal
				title="DELETE USER"
				open={show}
				handleClose={() => handleCancel()}
				maxWidth="sm"
				id="delete-user-form-asset-modal"
			>
				<MesfModal.Content dividers>
					<Typography>
						Delete <b>{UserName}</b> from this asset? Once deleted it cannot be
						recovered.
					</Typography>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 16px 16px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end" width="100%">
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide(false)}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }}>
							<ButtonWithLoading
								fullWidth
								isLoading={isSubmitLoading}
								variant="contained"
								color="secondary"
								onClick={handleRemoveUserFormAsset}
							>
								Delete
							</ButtonWithLoading>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
			<Snackbar
				open={userFormAssetRemovedSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert severity="info" onClose={handleClose}>
					Success
				</Alert>
			</Snackbar>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
